exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ba6-account-info[data-v-90ae7734]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:1rem}.ba6-p-element[data-v-90ae7734]{color:#4d5d71;font-size:12px;font-weight:500;letter-spacing:.66px}.ba6-phone-info-tooltip[data-v-90ae7734]{--builderall-icon-size:22px;--builderall-icon-color:#0072e1;padding:0 5px 6px 7px}.ba-bi-element[data-v-90ae7734]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-90ae7734","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/office-v6/account-settings/routes/AccountInfo.vue
// module id = I1N5
// module chunks = 0